export const VIP_BORDER_CLASSES = 'border-medium border-solid border-border-primary';
